export { ApiKeysService } from './ApiKeysService';
import { ApiKeysService } from './ApiKeysService';
export function createApiKeysServices(http, config) {
    return { apiKeys: new ApiKeysService(http, config) };
}
//# sourceMappingURL=index.js.map